/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  FormGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  Switch,
  LinearProgress
} from '@mui/material';

const PlayAnalysisGroundTruthForm = ({
  playAnalysisData,
  handleSubmit,
  requestState,
  actionRecognitionTestDatasetFlagUpdating,
  addToActionRecognitionTestDataset,
  ballBounceDetectionTestDatasetFlagUpdating,
  addToBallBounceDetectionTestDataset,
  adminUser = false,
}) => {
  const [returnShotType, setReturnShotType] =
        useState(playAnalysisData?.returnShotTypeGroundTruth?.trim()
          ? playAnalysisData.returnShotTypeGroundTruth.toLowerCase() : 'n/a');
  const [ballBounceLocation, setBallBounceLocation] =
        useState(playAnalysisData?.ballBounceLocationGroundTruth?.trim()
          ? playAnalysisData.ballBounceLocationGroundTruth.toLowerCase() : 'n/a');
  const [dataModified, setDataModified] = useState(false);

  useEffect(() => {
    if (playAnalysisData) {
      setReturnShotType(playAnalysisData.returnShotTypeGroundTruth || '');
      setBallBounceLocation(playAnalysisData.ballBounceLocationGroundTruth || '');
      setDataModified(false);
    }
  }, [playAnalysisData.ballLaunchSequenceNumber]);

  const onValueChange = (event) => {
    const { name, value } = event.target;
    if (name === 'return_shot_type_ground_truth') {
      setReturnShotType(value);
    } else if (name === 'ball_bounce_location_ground_truth') {
      setBallBounceLocation(value);
    }
    setDataModified(true);
  };

  const submitChanges = (e) => {
    if (!dataModified) {
      handleSubmit(e, 'n/a', 'n/a');
    } else {
      handleSubmit(e, returnShotType, ballBounceLocation);
    }
  };

  const handleActionRecognitionTestDatasetFlagChange = (event) => {
    addToActionRecognitionTestDataset(event);
  };

  const handleBallBounceDetectionTestDatasetFlagChange = (event) => {
    addToBallBounceDetectionTestDataset(event);
  };

  return (
        <Box width="25%" padding="0 1rem">
            {
                adminUser ? (
                    <Box width="100%" textAlign="center" marginBottom="1rem" minHeight="2.5rem">
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={!!playAnalysisData?.isActionRecognitionTestDataset || false}
                                        onChange={handleActionRecognitionTestDatasetFlagChange}
                                        disabled={actionRecognitionTestDatasetFlagUpdating}
                                        inputProps={{ 'aria-label': 'add-to-action-recognition-test-dataset' }}
                                        size="small"
                                    />
                                }
                                label="Action Recognition Test Dataset"
                            />
                        </FormGroup>
                        {actionRecognitionTestDatasetFlagUpdating && (
                            <Box width="100%" height="auto" margin="0.5rem 0">
                                <LinearProgress/>
                            </Box>
                        )}
                        <FormGroup sx={{ marginTop: '1rem' }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={!!playAnalysisData?.isBallBounceDetectionTestDataset || false}
                                        onChange={handleBallBounceDetectionTestDatasetFlagChange}
                                        disabled={ballBounceDetectionTestDatasetFlagUpdating}
                                        inputProps={{ 'aria-label': 'add-to-ball-bounce-detection-test-dataset' }}
                                        size="small"
                                    />
                                }
                                label={'Ball Bounce Detection Test Dataset'}
                            />
                        </FormGroup>
                        {ballBounceDetectionTestDatasetFlagUpdating && (
                            <Box width="100%" height="auto" margin="0.5rem 0">
                                <LinearProgress/>
                            </Box>
                        )}
                    </Box>
                ) : null
            }
            <Typography variant="h6" gutterBottom>
                Ground Truth Values
            </Typography>
            <Stack direction="column" justifyContent="center" margin={'1rem'}>
                <Box flexWrap="wrap" textAlign="left">
                    <FormControl style={{ marginTop: '1rem' }}>
                        <FormLabel id="return-shot-type-group-label"><b>Return Shot Type</b></FormLabel>
                        <RadioGroup
                            style={{ display: 'flex', flexDirection: 'row' }}
                            aria-labelledby="return-shot-type-group-label"
                            value={returnShotType}
                            name="return_shot_type_ground_truth"
                            onChange={onValueChange}
                        >
                            <FormControlLabel value="forehand" control={<Radio/>} label="Forehand"/>
                            <FormControlLabel value="backhand" control={<Radio/>} label="Backhand"/>
                            <FormControlLabel value="overhead_smash" control={<Radio/>} label="Overhead Smash"/>
                            <FormControlLabel value="no_action" control={<Radio/>} label="No Action"/>
                        </RadioGroup>
                    </FormControl>
                </Box>

                <Box textAlign="left">
                    <FormControl style={{ marginTop: '2rem' }}>
                        <FormLabel id="ball-bounce-location-group-label"><b>Ball Bounce Location</b></FormLabel>
                        <RadioGroup
                            aria-labelledby="ball-bounce-location-group-label"
                            value={ballBounceLocation}
                            name="ball_bounce_location_ground_truth"
                            style={{ display: 'flex', flexDirection: 'row' }}
                            onChange={onValueChange}
                        >
                            <FormControlLabel value="zone_1" control={<Radio/>} label="Zone 1"/>
                            <FormControlLabel value="zone_2" control={<Radio/>} label="Zone 2"/>
                            <FormControlLabel value="zone_3" control={<Radio/>} label="Zone 3"/>
                            <FormControlLabel value="zone_4" control={<Radio/>} label="Zone 4"/>
                            <FormControlLabel value="zone_5" control={<Radio/>} label="Zone 5"/>
                            <FormControlLabel value="zone_6" control={<Radio/>} label="Zone 6"/>
                            <FormControlLabel value="outside" control={<Radio/>} label="Outside"/>
                        </RadioGroup>
                    </FormControl>
                </Box>

                <Box
                    marginTop="1.5rem"
                    display="flex"
                    flexDirection="row"
                    justifyContent="flex-start"
                    alignContent="flex-start"
                    // alignItems="flex-start"
                    gap={1}
                >
                    <Button
                        // sx={{ width: '50%' }}
                        variant="contained"
                        size="small"
                        color={dataModified ? 'warning' : 'primary'}
                        disabled={requestState === 'in_progress'}
                        onClick={(e) => submitChanges(e)}
                    >
                        {dataModified ? 'Submit Changes' : 'No need to update'}
                    </Button>
                </Box>
                <Box width="auto" maxWidth="100%" marginTop="0.5rem">
                    {
                        requestState === 'in_progress' && (
                            <Alert variant="outlined" severity="info" style={{ maxWidth: '80%' }}>
                                {'Submitting request...'}
                            </Alert>
                        )
                    }
                    {
                        requestState === 'success' && (
                            <Alert variant="outlined" severity="success" style={{ maxWidth: '80%' }}>
                                {'Update successful!'}
                            </Alert>
                        )
                    }
                    {
                        requestState === 'failed' && (
                            <Alert variant="outlined" severity="error" style={{ maxWidth: '80%' }}>
                                {'Failed to update!'}
                            </Alert>
                        )
                    }
                </Box>
            </Stack>
        </Box>
  );
};

export default React.memo(PlayAnalysisGroundTruthForm);
